import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  Layout,
  Icon,
  Text,
  Col
} from 'athenaeum';

import CTA from 'components/CTA';

import styles from './sticky_nav.module.scss';

const StickyNav = (props) => {
  const {
    formType,
    actionPath,
    method,
    inputName,
    buttonText,
    placeholder,
    inputType,
    label,
    mobileLabel,
    mobileActionPath,
    className,
    attributes,
    ctaStyle,
  } = props;

  const mobileClasses = cx(
    styles['sticky-nav'],
    styles['mobile-layout'],
    className
  );

  const tabletUpClasses = cx(
    styles['sticky-nav'],
    styles['tablet-layout'],
    formType === 'single-field' && styles['single-field'],
    className
  );

  return (
    <nav
      className={cx(
        styles['sticky-nav-container'],
        styles['fade-in-up'],
      )}
      id="sticky-nav"
    >
      <Layout
        className={mobileClasses}
        smallCols={[6]}
      >
        <Text
          className={cx(styles.text, styles['fade-in-left'])}
          type={9}
          font="a"
        >
          {mobileLabel}
        </Text>
        <CTA
          inputClassName={styles.cta}
          className={cx(styles['mobile-button'], styles['fade-in-right'])}
          layoutProps={{ mediumCols: [6] }}
          method={method}
          type="single-button"
          actionPath={mobileActionPath || actionPath}
          buttonText={buttonText}
          placeholder={placeholder}
          inputType={inputType}
          inputName={inputName}
          attributes={attributes}
          stickyNavButtonId="sticky-nav-cta-button-mobile"
          ctaStyle={ctaStyle}
        />
      </Layout>

      <Layout
        className={tabletUpClasses}
        mediumCols={[1, 10]}
        largeCols={[1, 8]}
      >
        <Icon
          className={styles.icon}
          icon="policygeniusSymbol"
          height="46px"
        />
        <Col className={styles['text-and-cta-wrapper']}>
          <Text
            className={cx(styles.text, styles['fade-in-right'])}
            type={8}
            font="a"
          >
            {label}
          </Text>
          <CTA
            inputClassName={styles['cta-input']}
            className={styles.cta}
            type={formType}
            layoutProps={{ mediumCols: [6] }}
            method={method}
            actionPath={actionPath}
            buttonText={buttonText}
            placeholder={placeholder}
            inputType={inputType}
            inputName={inputName}
            attributes={attributes}
            stickyNavButtonId="sticky-nav-cta-button"
            ctaStyle={ctaStyle}
          />
        </Col>
      </Layout>
    </nav>
  );
};


StickyNav.propTypes = {
  /**
   * This prop will add a new className to any inherent classNames
   * provided in the component's index.js file.
   */
  formType: PropTypes.string,
  actionPath: PropTypes.string,
  method: PropTypes.string,
  inputName: PropTypes.string,
  buttonText: PropTypes.string,
  placeholder: PropTypes.string,
  inputType: PropTypes.string,
  label: PropTypes.string,
  mobileLabel: PropTypes.string,
  mobileActionPath: PropTypes.string,
  className: PropTypes.string,
  attributes: PropTypes.string,
  ctaStyle: PropTypes.string
};

StickyNav.defaultProps = {
  // Place any default props here.
};

export default StickyNav;



// WEBPACK FOOTER //
// ../src/templates/MainNav/StickyNav/index.js